import { dashboardLojaOptions } from '../../shared/lojaOptions';

const lojaLabelMap = dashboardLojaOptions.reduce((acc, option) => ({
  ...acc,
  [String(option.value).padStart(3, '0')]: option.label
}), {});

export const getLojaLabel = (loja) => lojaLabelMap[String(loja || '').padStart(3, '0')] || loja || '-';
